// extracted by mini-css-extract-plugin
export default {"upload-input":"styles_upload-input__64n3D"};